import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Divider, Stack, Typography, styled, } from '@mui/material';
import TextWithSeachHighlight from '../../textSearch/TextWithSeachHighlight';
import SearchEntryField from '../../textSearch/SearchEntryField';
const StyledDivider = styled(Divider)(() => ({
    borderBottomWidth: 2.5,
    marginTop: 0.4,
    marginBottom: 1,
}));
const Transcript = ({ transcript, courseName }) => {
    const [searchTerm, setSearchTerm] = useState('');
    useEffect(() => {
        setSearchTerm('');
    }, [transcript]);
    return (_jsxs(_Fragment, { children: [_jsxs(Stack, { direction: "row", spacing: 1, sx: { my: 1 }, justifyContent: "space-between", alignItems: "center", children: [_jsx(Typography, { variant: "subtitle1", fontWeight: "fontWeightBold", children: courseName }), _jsx(SearchEntryField, { searchTerm: searchTerm, setSearchTerm: setSearchTerm })] }), _jsx(StyledDivider, {}), _jsx(TextWithSeachHighlight, { text: transcript, searchTerm: searchTerm })] }));
};
export default Transcript;
//# sourceMappingURL=Transcript.js.map